import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import _ from 'lodash';
import { useCallback } from 'react';

export interface SearchInputProps {
  placeholder?: string;
  isSearching?: boolean;
  onSearch?: (search?: string) => void;
}

const SearchInput = ({
  placeholder,
  isSearching,
  onSearch,
}: SearchInputProps) => {
  const handleDebounceChange = useCallback(
    _.debounce((search) => {
      if (onSearch) {
        onSearch(search);
      }
    }, 500),
    [onSearch]
  );

  const handleChange = useCallback(
    (e: any) => {
      handleDebounceChange(e.target.value);
    },
    [handleDebounceChange]
  );

  return (
    <Input.Search
      placeholder={placeholder || 'Search'}
      allowClear
      style={{ width: 320 }}
      enterButton={<SearchOutlined />}
      onSearch={onSearch}
      loading={isSearching}
      disabled={isSearching}
      onChange={handleChange}
    />
  );
};

export default SearchInput;
